import React, { useState } from "react";
import { FocusOn } from "react-focus-on";
import { styled } from "styled-components";
import TransparentIconButton from "../TransparentIconButton";
import { Info } from "../../icons";
import Tooltip from "../Tooltip";
import rem from "../../utils/rem";
const TooltipWrapper = styled.div `
  display: block;
  margin-left: ${rem(13)};
`;
export const InputTooltip = ({ text, position, buttonTitle, }) => {
    const [showTooltip, setShowTooltip] = useState(false);
    const [toggleCanOpenTooltip, setToggleCanOpenTooltip] = useState(true);
    const handleOpenTooltip = (event) => {
        event.preventDefault();
        if (toggleCanOpenTooltip) {
            setShowTooltip(true);
            setToggleCanOpenTooltip(false);
        }
    };
    const handleOpenTooltipKeyCode = (event) => {
        const keys = ["Enter", "ArrowDown", "ArrowRight", " "];
        if (keys.indexOf(event.key) !== -1) {
            event.preventDefault();
            if (toggleCanOpenTooltip) {
                setShowTooltip(true);
                setToggleCanOpenTooltip(false);
            }
        }
    };
    const onFocusTrapForTooltipDeactivate = () => {
        setShowTooltip(false);
        setTimeout(() => setToggleCanOpenTooltip(true), 200);
    };
    return (React.createElement(TooltipWrapper, null,
        React.createElement(TransparentIconButton, { title: buttonTitle, iconColor: "GRAY_DARK", icon: Info, onMouseDown: toggleCanOpenTooltip ? handleOpenTooltip : undefined, onKeyDown: toggleCanOpenTooltip ? handleOpenTooltipKeyCode : undefined }),
        showTooltip && (React.createElement(FocusOn, { onEscapeKey: onFocusTrapForTooltipDeactivate, onClickOutside: onFocusTrapForTooltipDeactivate },
            React.createElement(Tooltip, { transformToParent: true, absolute: true, position: position, length: "fixed" }, text())))));
};
export default InputTooltip;
//# sourceMappingURL=InputTooltip.js.map